﻿export const isElement = (node: object): node is Element => node instanceof Element;

export const isHTMLInputElement = (node: object): node is HTMLInputElement =>
  node instanceof HTMLInputElement;

export const isHTMLElement = (node: object): node is HTMLElement =>
  node instanceof HTMLElement;

export const isString = (value: unknown): value is string => typeof value === "string";

export const isNumber = (value: unknown): value is number =>
  typeof value === "number" && !isNaN(value);
